import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach's My Membership page — the title and a
// single membership card (colored header band, a details grid, a features list).
export default function CoachMembershipSkeleton({ isDarkMode }) {
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`max-w-2xl mx-auto space-y-6 py-10 px-4 ${isDarkMode ? "bg-surface" : ""}`}>
                <Skeleton width={200} height={28} />
                <div className={`rounded-2xl border overflow-hidden ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200 shadow-sm"}`}>
                    {/* Header band */}
                    <Skeleton height={92} borderRadius={0} />
                    {/* Body */}
                    <div className="px-6 py-5 space-y-5">
                        <div className="grid grid-cols-2 gap-4">
                            {Array.from({ length: 4 }).map((_, i) => (
                                <div key={i}>
                                    <Skeleton width={80} height={11} />
                                    <Skeleton width={120} height={16} className="mt-1" />
                                </div>
                            ))}
                        </div>
                        <div className="space-y-2">
                            {Array.from({ length: 4 }).map((_, i) => (
                                <Skeleton key={i} height={14} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
